export default __webpack_public_path__ + "static/media/invoicedot.4496c1e5.svg";